import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewMode", "editMode", "editButton", "confirmButton", "cancelButton", "form", "input"]
  static values = {
    iconMode: { type: Boolean, default: false }
  }

  connect() {
    // Store original value for cancel functionality
    if (this.hasInputTarget) {
      this.originalValue = this.inputTarget.value
    }
  }

  enterEditMode(event) {
    if (event) event.preventDefault()
    
    // Hide view mode, show edit mode
    this.viewModeTarget.classList.add("hidden")
    this.editModeTarget.classList.remove("hidden")
    
    // Update button visibility based on mode
    if (this.iconModeValue) {
      // Icon mode: hide edit button, show confirm/cancel buttons
      this.editButtonTarget.classList.add("hidden")
      
      if (this.hasConfirmButtonTarget) {
        this.confirmButtonTarget.classList.remove("hidden")
      }
      
      if (this.hasCancelButtonTarget) {
        this.cancelButtonTarget.classList.remove("hidden")
      }
    } else {
      // Text mode: update button text
      this.editButtonTarget.textContent = "Cancel"
    }
    
    // Focus the input field
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }

  exitEditMode(event) {
    if (event) event.preventDefault()
    
    // Hide edit mode, show view mode
    this.viewModeTarget.classList.remove("hidden")
    this.editModeTarget.classList.add("hidden")
    
    // Update button visibility based on mode
    if (this.iconModeValue) {
      // Icon mode: show edit button, hide confirm/cancel buttons
      this.editButtonTarget.classList.remove("hidden")
      
      if (this.hasConfirmButtonTarget) {
        this.confirmButtonTarget.classList.add("hidden")
      }
      
      if (this.hasCancelButtonTarget) {
        this.cancelButtonTarget.classList.add("hidden")
      }
    } else {
      // Text mode: update button text
      this.editButtonTarget.textContent = "Edit Notes"
    }
  }

  // Toggle between edit and view modes (for backward compatibility)
  toggleEdit(event) {
    if (event) event.preventDefault()
    
    if (this.viewModeTarget.classList.contains("hidden")) {
      this.exitEditMode()
    } else {
      this.enterEditMode()
    }
  }

  saveChanges(event) {
    if (event) event.preventDefault()
    
    // Submit the form
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
    
    // Return to view mode
    this.exitEditMode()
  }

  cancelEdit(event) {
    if (event) event.preventDefault()
    
    // Reset the input to original value
    if (this.hasInputTarget && this.originalValue !== undefined) {
      this.inputTarget.value = this.originalValue
    }
    
    // Return to view mode
    this.exitEditMode()
  }
}
